import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import {
  getAllEmployeeTasks,
  getAllVehicleSlots,
  getgeneralNestedItemdualcondition,
  getgeneralNestedItemdualconditionvehicles,
  getgeneralNestedItemdualconditionvehiclesSupervisor,
  getprojectvehichles,
  getprojectvehichlesforsupervisors,
  gettaskscreatedbysupervisors,
  gettasksforsupervisors,
  gettasksoverview,
  saveitem,
  saveuserdata,
  savevehicledata,
  updateItem,
} from "../../utils/firebasefunctions";
import { downloadExcel } from "react-export-table-to-excel";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../context/StateProvider";
import { ToastContainer, toast } from "react-toastify";
import { GoPlus } from "react-icons/go";
import { RotatingLines } from "react-loader-spinner";
import { FaCar } from "react-icons/fa";
import userlogo from "../images/user.png";
import { FaUser } from "react-icons/fa";
import { actionType } from "../context/reducer";
import {
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { storage, app } from "../../firebase.config";
import Reminderpopup from "../components/Reminderpopup";
import CurrentReminders from "../components/CurrentReminders";
import Vehicledropdown from "../components/Vehicledropdown";
import { IoIosCloseCircle } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import moment from "moment";
import VehicleHistory from "../components/VehicleHistory";
import EmployeePopup from "../components/EmployeePopup";
import { arrayUnion } from "firebase/firestore";
import Taskpopup from "../components/Taskpopup";
import TaskRejection from "../components/TaskRejection";
import HorizontalDatePicker from "../components/HorizontalDatePicker";
import HorizontalDattePickerWrap from "../components/HorizontalDattePickerWrap";

function ToDolist() {
  const [{ user, employees }, dispatch] = useStateValue();
  const [vehiclenumber, setvehiclenumber] = useState("");
  const [supervisortasks, setsupervisortasks] = useState([]);

  const [vehiclelist, setvehiclelist] = useState([]);

  const [loader, setloader] = useState(false);
  const [picturedata, setpicturedata] = useState("");
  const [vehicles, setvehicles] = useState([]);

  const [laoding, setloading] = useState(false);
  const [generalreminders, setgeneralreminders] = useState([]);
  const [vehiclehistorydata, setvehiclehistorydata] = useState([]);
  const [vehiclepopup, setvehiclepopup] = useState(false);
  const [rejectionpopup, setrejectionpopup] = useState(false);
  const [selecteddate, setselecteddate] = useState(new Date());
  const [startdate, setstartdate] = useState(
    new Date(new Date().setHours(0, 0, 0, 0)),
  );
  const [enddate, setenddate] = useState(
    new Date(new Date().setHours(23, 59, 59, 59)),
  );
  const [employeepopup, setemployeepopup] = useState(false);
  const [reminderpopup, setreminderpopup] = useState(false);
  const [currentreminderpopup, setcurrentreminderpopup] = useState(false);
  const [vehiclehistorypopup, setvehiclehistorypopup] = useState(false);
  const [vehiclereminders, setvehiclereminders] = useState([]);
  const [selectedemployee, setselectedemployee] = useState([]);
  const [rejectionindex, setrejectionindex] = useState(0);

  const [picture, setpicture] = useState("");
  const [selectedtype, setselectedtype] = useState("My Tasks");
  const fileInput = useRef();
  const header = ["Vehicle Number", "Time", "Reminder"];
  useEffect(() => {
    gettasks();
  }, [selectedtype]);

  useEffect(() => {
    let startingdate = new Date();
    startingdate.setMonth(startingdate.getMonth() - 3);
    let endingdate = new Date();
    endingdate.setMonth(endingdate.getMonth() + 3);
    setstartdate(startingdate);

    setenddate(endingdate);
  }, []);
  // useEffect(() => {
  //   if (user.usertype == "Supervisor") {
  //     getgeneralhoursforSupervisor();
  //   } else {
  //     getgeneralhours();
  //   }
  // }, [startdate, enddate, vehiclelist]);
  const gettasks = async () => {
    if (selectedtype == "My Tasks") {
      assignedtasks();
    } else if (selectedtype == "Created Tasks") {
      createdtasks();
    } else {
      overviewtasks();
    }
  };

  const overviewtasks = async () => {
    if (user.usertype == "Supervisor") {
      let allprojects = user.projectassigned.map((item) => item.project);

      setloader(true);
      await gettasksoverview("supervisortasks", allprojects)
        .then(async (response) => {
          if (response.length > 0) {
            setsupervisortasks(response);
            // console.log("tasks new" + JSON.stringify(response[0]));
          }
          setloader(false);
        })
        .catch((err) => {
          alert(err);
          setloader(false);
        });
    }
  };

  const assignedtasks = async () => {
    if (user.usertype == "Supervisor") {
      setloader(true);
      await gettasksforsupervisors("supervisortasks", user.id)
        .then(async (response) => {
          if (response.length > 0) {
            setsupervisortasks(response);
            console.log("my tassks " + JSON.stringify(response[4]));
          }
          setloader(false);
        })
        .catch((err) => {
          alert(err);
          console.log(err);
          setloader(false);
        });
    }
  };

  const createdtasks = async () => {
    if (user.usertype == "Supervisor") {
      setloader(true);
      await gettaskscreatedbysupervisors("supervisortasks", user.id)
        .then(async (response) => {
          if (response.length > 0) {
            setsupervisortasks(response);
          }
          setloader(false);
        })
        .catch((err) => {
          alert(err);
          console.log(err);
          setloader(false);
        });
    }
  };

  const getgeneralhoursforSupervisor = async () => {
    setloading(true);
    setgeneralreminders([]);

    if (vehicles.find((data) => data.selected == true) == undefined) {
      let dataset = [];
      for (const key in vehiclelist) {
        dataset.push(vehiclelist[key].registrationnumber);
      }
      await getgeneralNestedItemdualconditionvehiclesSupervisor(
        "reminders",
        "remindertimestamp",
        ">=",
        startdate.getTime(),
        "remindertimestamp",
        "<=",
        enddate.getTime(),
        "registrationnumber",
        "in",
        dataset,
      )
        .then(async (response) => {
          setloading(false);
          setgeneralreminders(response);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    } else {
      let dataset = [];
      for (const key in vehiclelist) {
        if (vehiclelist[key].selected == true) {
          dataset.push(vehiclelist[key].registrationnumber);
        }
      }

      await getgeneralNestedItemdualconditionvehicles(
        "reminders",
        "remindertimestamp",
        ">=",
        startdate.getTime(),
        "remindertimestamp",
        "<=",
        enddate.getTime(),
        "registrationnumber",
        "in",
        dataset,
        false,
      )
        .then(async (response) => {
          setloading(false);
          setgeneralreminders(response);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    }
  };
  const getgeneralhours = async () => {
    setloading(true);
    setgeneralreminders([]);

    if (vehicles.find((data) => data.selected == true) == undefined) {
      await getgeneralNestedItemdualconditionvehicles(
        "reminders",
        "remindertimestamp",
        ">=",
        startdate.getTime(),
        "remindertimestamp",
        "<=",
        enddate.getTime(),
        "createdby",
        "==",
        user.usertype == "Supervisor" ? user.createdby : user.id,
        true,
      )
        .then(async (response) => {
          setloading(false);
          setgeneralreminders(response);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    } else {
      let dataset = [];
      for (const key in vehiclelist) {
        if (vehiclelist[key].selected == true) {
          dataset.push(vehiclelist[key].registrationnumber);
        }
      }

      await getgeneralNestedItemdualconditionvehicles(
        "reminders",
        "remindertimestamp",
        ">=",
        startdate.getTime(),
        "remindertimestamp",
        "<=",
        enddate.getTime(),
        "registrationnumber",
        "in",
        dataset,
        false,
      )
        .then(async (response) => {
          setloading(false);
          setgeneralreminders(response);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    }
  };

  const handletaskChange = (event) => {
    setvehiclenumber(event.target.value);
  };

  const addasset = async () => {
    let selectedemployeelist = selectedemployee
      .filter((emp) => emp.selected) // Keep only selected ones
      .map((emp) => emp.id);

    if (vehiclenumber == "") {
      toast.warn("Please fill out a vehicle number");
    } else {
      setloader(true);

      if (picturedata != "") {
        const imageFile = picturedata.target.files[0];
        const storageRef = ref(
          storage,
          `vehiclepicture/${Date.now()}-${imageFile.name}`,
        );
        const uploadTask = uploadBytesResumable(storageRef, imageFile);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            //   const uploadProgress = (snapshot.bytesTransferred/snapshot.totalBytes)*100
          },
          (error) => {
            setloader(false);
            toast.error("upload error " + error.message);
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref)
              .then(async (downloadURL) => {
                let data = {
                  id: Date.now(),
                  creationdate: Date.now(),
                  logo: downloadURL,
                  registrationnumber: vehiclenumber,
                  createdby:
                    user.usertype == "Supervisor" ? user.createdby : user.id,
                  assignedsupervisors: selectedemployeelist,
                };

                await savevehicledata(data, data.id)
                  .then(async (response) => {
                    if (response == "success") {
                      toast.success("Vehicle Created Successfully");
                      if (selectedemployeelist.length > 0) {
                        for (const key in selectedemployeelist) {
                          let datavehicles = {
                            vehiclesassigned: arrayUnion(data.id),
                          };

                          await updateItem(
                            "users",
                            selectedemployeelist[key],
                            datavehicles,
                          )
                            .then((response) => {
                              if (key == selectedemployeelist.length - 1) {
                                setselectedemployee([]);
                                let employeesdata = [...employees];
                                for (const key in employeesdata) {
                                  employeesdata[key].selected = false;
                                }

                                dispatch({
                                  type: actionType.STORE_EMPLOYEES,
                                  payload: employeesdata,
                                });
                              }
                            })
                            .catch((err) => {
                              alert("update employee error " + err);
                              setloader(false);
                            });
                        }
                      }
                      setvehiclenumber("");
                      setpicture("");
                      setpicturedata("");
                    } else {
                      toast.error(
                        "Something went wrong while posting your task. Please try again later.",
                      );
                    }

                    setloader(false);
                  })
                  .catch((err) => {
                    alert(err);
                    setloader(false);
                  });
              })
              .catch((error) => {
                setloader(false);
                toast.error(error.message);
              });
          },
        );
      } else {
        let data = {
          id: Date.now(),
          creationdate: Date.now(),
          logo: "",
          registrationnumber: vehiclenumber,
          createdby: user.usertype == "Supervisor" ? user.createdby : user.id,
          assignedsupervisors: selectedemployeelist,
        };

        await savevehicledata(data, data.id)
          .then(async (response) => {
            if (response == "success") {
              toast.success("Vehicle Created Successfully");

              if (selectedemployeelist.length > 0) {
                for (const key in selectedemployeelist) {
                  let datavehicles = {
                    vehiclesassigned: arrayUnion(data.id),
                  };

                  await updateItem(
                    "users",
                    selectedemployeelist[key],
                    datavehicles,
                  )
                    .then((response) => {
                      if (key == selectedemployeelist.length - 1) {
                        setselectedemployee([]);
                        let employeesdata = [...employees];
                        for (const key in employeesdata) {
                          employeesdata[key].selected = false;
                        }

                        dispatch({
                          type: actionType.STORE_EMPLOYEES,
                          payload: employeesdata,
                        });
                      }
                    })
                    .catch((err) => {
                      alert("update employee error " + err);
                      setloader(false);
                    });
                }
              }
              setvehiclenumber("");
              setpicture("");
              setpicturedata("");
            } else {
              toast.error(
                "Something went wrong while posting your task. Please try again later.",
              );
            }

            setloader(false);
          })
          .catch((err) => {
            alert(err);
            setloader(false);
          });
      }
    }
  };

  const handleimageChange = (event) => {
    fileInput.current.click();
  };

  const handleimageselected = (e) => {
    setpicturedata(e);
    setpicture(URL.createObjectURL(e.target.files[0]));
  };

  const handleDownloadExcelGeneral = () => {
    let newdata = [];
    let newgeneralemployeecheckindata = [...generalreminders];
    newgeneralemployeecheckindata.map((val, id) => {
      newdata.push([
        val?.registrationnumber,
        moment(val.remindertimestamp).format("YYYY-MM-DD hh:mm"),
        val.remindernote,
      ]);
    });

    downloadExcel({
      fileName: "Reminder Sheet",
      sheet: "Reminder-Sheet",
      tablePayload: {
        header,
        body: newdata,
      },
    });
  };

  const deletetaskreminder = async (item, index) => {
    // const res = await fetch(
    //   "https://us-central1-raftekpro-82bb0.cloudfunctions.net/cancelOneTimeJob",
    //   {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       taskName: item?.schecduledtaskname,
    //     }),
    //   }
    // );
    let data = {};
    // if (res.status == 200) {
    // console.log("Notififcation " + JSON.stringify(res));
    // const dataresponse = await res.json();

    console.log("Successfully deleted User");
    data = {
      deleted: true,
      // scheduledjobdeleted: true,
    };
    // } else {
    //   data = {
    //     deleted: true,
    //     // scheduledjobdeleted: false,
    //   };

    //   console.log(res.error + "error message");
    // }

    await updateItem("supervisortasks", item.id, data)
      .then((response) => {
        let dataset = [...supervisortasks];
        dataset[index]["deleted"] = true;
        // dataset[index]["scheduledjobdeleted"] = data.scheduledjobdeleted;

        setsupervisortasks(dataset);
        toast.success("Task Deleted Successfully");
        setloader(false);
      })
      .catch((err) => {
        alert("update task error " + err);
      });
  };

  const terminatetaskreminder = async (item, index) => {
    let data = {};

    console.log("Successfully deleted User");
    data = {
      nextruncompleted: true,
    };

    await updateItem("supervisortasks", item.id, data)
      .then((response) => {
        let dataset = [...supervisortasks];
        dataset[index]["nextruncompleted"] = true;
        // dataset[index]["scheduledjobdeleted"] = data.scheduledjobdeleted;

        setsupervisortasks(dataset);
        toast.success("Task Terminated Successfully");
        setloader(false);
      })
      .catch((err) => {
        alert("update task error " + err);
      });
  };

  const selectedDay = (val) => {
    setselecteddate(val);
  };

  return (
    <div className="w-[100%] flex flex-col items-center  mt-[70px] md:mt-[0px] ">
      <div className=" flex flex-row w-full justify-between  pb-[30px] ">
        <p className="text-[22px] text-textcolor PoppinsRegular  self-start ">
          To Do List
        </p>

        <button
          onClick={() => {
            setreminderpopup(true);
          }}
          type="submit"
          className={`bg-cardOverlay  drop-shadow-lg  text-center py-2 rounded-md
           bg-themeblue hover:bg-themeblue/80 text-white
          "
          } px-[10px]   text-sm  PoppinsRegular uppercase`}
        >
          Create Task
        </button>
      </div>

      <div className=" flex flex-row w-full   ">
        <button
          onClick={() => {
            setselectedtype("My Tasks");
          }}
          type="submit"
          className={`bg-cardOverlay  drop-shadow-lg  text-center py-2 rounded-md ${
            selectedtype == "My Tasks"
              ? "bg-themeblue hover:bg-themeblue/80 text-white"
              : " bg-themelightblack hover:bg-themelightblack/80 text-textcolor"
          } px-[10px]   text-sm  PoppinsRegular uppercase`}
        >
          My Tasks
        </button>

        <button
          onClick={() => {
            setselectedtype("Created Tasks");
          }}
          type="submit"
          className={`text-center py-2 rounded-md ml-[5px] ${
            selectedtype == "Created Tasks"
              ? "bg-themeblue hover:bg-themeblue/80  text-white"
              : "bg-themelightblack hover:bg-themelightblack/80  text-textcolor"
          } px-[10px]  text-sm  PoppinsRegular uppercase bg-cardOverlay  drop-shadow-lg`}
        >
          Created Tasks
        </button>
        <button
          onClick={() => {
            setselectedtype("Overview");
          }}
          type="submit"
          className={`text-center py-2 rounded-md ml-[5px] ${
            selectedtype == "Overview"
              ? "bg-themeblue hover:bg-themeblue/80  text-white"
              : "bg-themelightblack hover:bg-themelightblack/80  text-textcolor"
          } px-[10px]  text-sm  PoppinsRegular uppercase bg-cardOverlay  drop-shadow-lg`}
        >
          Overview
        </button>
      </div>
      <div className=" bg-themelightblack w-[100%]  px-[20px] py-[30px]  border border-bordercolor mx-auto  bg-cardOverlay rounded-xl  drop-shadow-lg mt-[10px] ">
        {loader ? (
          <div className="w-full py-4  mt-6  flex justify-center  ">
            <RotatingLines
              visible={true}
              height="25"
              width="25"
              color="grey"
              strokeColor="#00C763"
              strokeWidth="5"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        ) : (
          <div className=" overflow-x-auto  border border-bordercolor mt-5  bg-cardOverlay rounded-xl  drop-shadow-lg overflow-y-scroll m-h-[45%]">
            {selectedtype == "Overview" ? (
              <HorizontalDattePickerWrap
                startDate={startdate}
                endDate={enddate}
                selectedDate={selecteddate}
                onDateSelected={selectedDay}
                supervisortasks={supervisortasks}
              />
            ) : (
              <table className="w-full min-w-full divide-y divide-bordercolor bg-themelightblack text-sm">
                <thead className="ltr:text-left rtl:text-right">
                  <tr>
                    {selectedtype == "Created Tasks" && (
                      <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor"></th>
                    )}

                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                      Assigned By
                    </th>

                    {/* <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                      Time
                    </th> */}
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                      Assigned To
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor ">
                      Task
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                      Status
                    </th>

                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                      Deadline
                    </th>

                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                      Type
                    </th>

                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor"></th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-bordercolor text-center">
                  {supervisortasks &&
                    supervisortasks.map(
                      (item, index) =>
                        !item.deleted && (
                          <tr
                            key={index.toString()}
                            className={` ${
                              item.Status == "Rejected" ? "bg-black" : null
                            } hover:bg-[#0989B826]/10 cursor-pointer`}
                            onClick={() => {}}
                          >
                            {selectedtype == "Created Tasks" && (
                              <td className="whitespace-nowrap px-2 py-2 PoppinsRegular ">
                                <div className="flex flex-row items-center justify-center">
                                  <MdDelete
                                    onClick={async () => {
                                      deletetaskreminder(item, index);
                                    }}
                                    className=" text-lighttextGray hover:text-red-500   w-[20px] h-[20px] hover:cursor-pointer"
                                  />

                                  {item?.nextruncompleted == false && (
                                    <button
                                      onClick={async () => {
                                        terminatetaskreminder(item, index);
                                      }}
                                      type="submit"
                                      className="text-center w-[125px] py-[5px] rounded-md bg-red-500 text-white text-sm PoppinsRegular uppercase ml-[10px] "
                                    >
                                      Terminate
                                    </button>
                                  )}
                                </div>
                              </td>
                            )}
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor">
                              {employees
                                .filter((x) => item.createdby == x.id)
                                .map((inneritem, ind) => {
                                  return (
                                    inneritem.firstname +
                                    " " +
                                    inneritem.lastname
                                  );
                                })}
                            </td>

                            {/* <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor">
                              {item.id
                                ? moment(item.id).format("YYYY-MM-DD hh:mm")
                                : null}
                            </td> */}
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor ">
                              <div className="flex flex-row  justify-center">
                                {employees
                                  .filter((x) =>
                                    item.employeelist.find(
                                      (itemdata) => itemdata == x.id,
                                    ),
                                  )
                                  .map((inneritem, ind) => {
                                    return (
                                      <div className="flex  flex-col justify-center items-center">
                                        <img
                                          loading="lazy"
                                          style={{
                                            marginLeft:
                                              employees.filter((x) =>
                                                item.employeelist.find(
                                                  (itemdata) =>
                                                    itemdata == x.id,
                                                ),
                                              ).length > 1 && ind != 0
                                                ? -50
                                                : 0,
                                          }}
                                          src={
                                            inneritem.profilepicture
                                              ? inneritem.profilepicture
                                              : userlogo
                                          }
                                          className="w-[30px] h-[30px] rounded-full object-cover"
                                        />
                                        <p className="pt-[5px]">
                                          {inneritem.firstname +
                                            " " +
                                            inneritem.lastname}
                                        </p>
                                      </div>
                                    );
                                  })}
                              </div>
                            </td>
                            <td className=" px-4 py-2 PoppinsRegular  text-textcolor text-left ">
                              <div className=" flex  overflow-hidden w-[200px] ">
                                <p> {item?.task}</p>
                              </div>
                            </td>
                            <td
                              className={`whitespace-nowrap px-4 py-2 PoppinsRegular   ${
                                item?.Status == "Rejected"
                                  ? "text-red-600"
                                  : item?.Status == "Completed"
                                    ? "text-themegreen"
                                    : "text-orange-500"
                              }`}
                            >
                              {item.Status}
                            </td>

                            <td
                              className={`whitespace-nowrap px-4 py-2 PoppinsRegular   text-textcolor`}
                            >
                              {/* {Date.now() > item.deadlinetimestamp
                                  ? "Delivered"
                                  : "Pending"} */}
                              {moment(item.deadlinetimestamp).format(
                                "YYYY-MM-DD HH:mm",
                              )}
                            </td>

                            <td
                              className={`whitespace-nowrap px-4 py-2 PoppinsRegular   ${
                                item?.type == "Daily"
                                  ? "text-yellow-300"
                                  : item?.type == "One Time"
                                    ? "text-themegreen"
                                    : item?.type == "Weekly"
                                      ? "text-orange-500"
                                      : item?.type == "Monthly"
                                        ? "text-purple-500"
                                        : "text-red-500"
                              }`}
                            >
                              {item.type}
                            </td>
                            <td className="pr-[15px] md:pr-[0px]">
                              {item.Status != "Completed" &&
                              item.Status != "Rejected" ? (
                                item.employeelist.find(
                                  (sup) => sup === user.id,
                                ) != undefined && (
                                  <div className="flex flex-row justify-center w-[300px]">
                                    <button
                                      onClick={async () => {
                                        let now = Date.now();
                                        await updateItem(
                                          "supervisortasks",
                                          item.id,
                                          {
                                            Status: "Completed",
                                            completiontimestamp: now,
                                          },
                                        )
                                          .then((response) => {
                                            let dataset = [...supervisortasks];
                                            dataset[index]["Status"] =
                                              "Completed";
                                            dataset[index][
                                              "completiontimestamp"
                                            ] = now;

                                            setsupervisortasks(dataset);
                                          })
                                          .catch((err) => {
                                            alert("update task error " + err);
                                          });
                                      }}
                                      type="submit"
                                      className="text-center w-[125px] py-[5px] rounded-md bg-themegreen text-white text-sm PoppinsRegular uppercase  "
                                    >
                                      Mark Complete
                                    </button>
                                    <button
                                      onClick={async () => {
                                        setrejectionpopup(true);
                                        setrejectionindex(index);
                                      }}
                                      type="submit"
                                      className="ml-[10px] text-center w-[125px] py-[5px] rounded-md bg-red-600 text-white text-sm PoppinsRegular uppercase  "
                                    >
                                      Reject
                                    </button>
                                  </div>
                                )
                              ) : item.Status == "Rejected" ? (
                                <p className="px-4 py-2 PoppinsRegular  text-red-600 text-left">
                                  {" "}
                                  {item?.RejectionReason}
                                </p>
                              ) : null}
                            </td>
                          </tr>
                        ),
                    )}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>

      {selectedtype == "Statsremoved" && (
        <div className=" bg-themelightblack w-[100%]  px-[20px] py-[30px]  border border-bordercolor mx-auto  bg-cardOverlay rounded-xl  drop-shadow-lg mt-[10px] ">
          {generalreminders?.length > 0 && (
            <div className="flex flex-row w-full justify-end items-end py-[10px]">
              <button
                onClick={() => handleDownloadExcelGeneral()}
                type="submit"
                className="text-center px-[10px] py-[5px] rounded-md bg-themeColor text-white text-sm PoppinsRegular uppercase  "
              >
                Export
              </button>
            </div>
          )}

          <div className="w-[90%] lg:w-[95%] mx-auto flex flex-row flex-wrap justify-between items-center">
            <div className="w-full lg:w-[24%] mt-4 lg:mt-0">
              <p className="PoppinsRegular  text-textcolor/80 text-sm pb-1">
                Select Vehicle
              </p>
              <div className="flex relative  w-full">
                <div
                  onClick={() => {
                    setvehiclepopup(!vehiclepopup);
                  }}
                  className="px-4 text-textcolor text-sm  PoppinsRegular w-full py-[10px] rounded-xl border border-bordercolor items-center flex flex-wrap "
                >
                  {vehiclelist?.length == 0 ||
                  vehiclelist.find((data) => data.selected == true) == undefined
                    ? "Select Vehicle"
                    : vehiclelist
                        .filter(function (data) {
                          return data.selected == true;
                        })
                        .map(function (data) {
                          return (
                            <div
                              onClick={() => {
                                let dataset = [...vehicles];
                                const designationindex = dataset.findIndex(
                                  (item) => item.id === data.id,
                                );
                                dataset[designationindex].selected = false;
                                setvehiclelist(dataset);
                              }}
                              className="bg-themeColor px-[5px] py-[1px] mr-[5px] rounded-md flex flex-row items-center mb-[2px]"
                            >
                              <p className="text-white ">
                                {data.registrationnumber}
                              </p>
                              <IoIosCloseCircle
                                onClick={(id) => {
                                  console.log(id);
                                }}
                                className=" text-white ml-[3px]  w-[15px] h-[15px] hover:cursor-pointer"
                              />
                            </div>
                          );
                        })}
                </div>
                <Vehicledropdown
                  bulkaction={(status) => {
                    let data = [...vehiclelist];
                    // Update the main 'employees' array to mark the selected ones
                    const updatedArray = data.map((item) => ({
                      ...item,
                      selected: status,
                    }));
                    setvehiclelist(updatedArray);
                  }}
                  multi={true}
                  visible={vehiclepopup}
                  data={vehiclelist}
                  activateoutsidecontainerclick={() => {
                    setvehiclepopup(false);
                  }}
                  onClick={(item, index) => {
                    let data = [...vehiclelist];
                    data[index].selected = !data[index].selected;
                    setvehiclelist(data);
                  }}
                />
              </div>
            </div>

            <div className="w-full lg:w-[24%] mt-4 lg:mt-0">
              <p className="PoppinsRegular  text-textcolor/80 text-sm pb-1">
                From
              </p>
              <DatePicker
                className="input PoppinsRegular  border border-bordercolor rounded-xl w-full"
                selected={startdate}
                onChange={(date) =>
                  setstartdate(new Date(date.setHours(0, 0, 0, 0)))
                }
              />
            </div>
            <div className="w-full lg:w-[24%] mt-4 lg:mt-0">
              <p className="PoppinsRegular  text-textcolor/80 text-sm pb-1">
                To
              </p>
              <DatePicker
                className="input PoppinsRegular  border border-bordercolor rounded-xl w-full"
                selected={enddate}
                onChange={(date) =>
                  setenddate(new Date(date.setHours(23, 59, 59, 59)))
                }
              />
            </div>
          </div>

          <div className=" overflow-x-auto  border border-bordercolor mt-5  bg-cardOverlay rounded-xl  drop-shadow-lg overflow-y-scroll m-h-[45%]">
            {laoding ? (
              <div className=" py-4  mt-6 w-full flex justify-center  ">
                <RotatingLines
                  visible={true}
                  height="25"
                  width="25"
                  color="grey"
                  strokeColor="#00C763"
                  strokeWidth="5"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : (
              <table className="min-w-full divide-y divide-bordercolor bg-themelightblack text-sm ">
                <thead className="ltr:text-left rtl:text-right">
                  <tr>
                    {/* <th className="whitespace-nowrap py-2 px-2  PoppinsRegular text-textcolor"></th> */}
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                      Vehicle Number
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                      Time
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor "></th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor text-left">
                      Reminder
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-bordercolor text-center">
                  {generalreminders &&
                    generalreminders.map(
                      (item, index) =>
                        !item.delete && (
                          <tr
                            key={index.toString()}
                            className="hover:bg-[#0989B826]/10 cursor-pointer h-[90px]"
                            onClick={() => {}}
                          >
                            {/* <td className="whitespace-nowrap px-2 py-2 PoppinsRegular  ">
                            <MdDelete
                              onClick={() => {
                                // deletereminder(item.id, index);
                              }}
                              className=" text-lighttextGray hover:text-themegreen   w-[20px] h-[20px] hover:cursor-pointer ml-[10px]"
                            />
                          </td> */}
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor pr-[20px]">
                              {item.registrationnumber}
                            </td>
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor pr-[20px]">
                              {moment(item.remindertimestamp).format(
                                "YYYY-MM-DD hh:mm",
                              )}
                            </td>
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor ">
                              <div className="flex flex-row w-[150px] ">
                                {employees
                                  .filter(
                                    (x) =>
                                      item.employeelist.find(
                                        (item) => item == x.id,
                                      ) != undefined,
                                  )
                                  .map((itemdata, ind) => {
                                    return (
                                      <img
                                        loading="lazy"
                                        style={{
                                          marginLeft: 5,
                                          //   marginLeft:
                                          //     employees.filter(
                                          //       (x) =>
                                          //         item.employeelist.find(
                                          //           (item) => item == x.id
                                          //         ) != undefined
                                          //     ).length > 1
                                          //       ? -50
                                          //       : 0,
                                        }}
                                        src={
                                          itemdata.profilepicture
                                            ? itemdata.profilepicture
                                            : userlogo
                                        }
                                        className="w-[35px] h-[35px] rounded-full object-cover"
                                      />
                                    );
                                  })}
                              </div>
                            </td>
                            <td className="whitespace-nowrap pl-4 py-2 PoppinsRegular  text-textcolor text-left pr-[20px]">
                              {item.remindernote}
                            </td>
                          </tr>
                        ),
                    )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      <Taskpopup
        visible={reminderpopup}
        activateoutsidecontainerclick={() => {
          setreminderpopup(false);
        }}
        refresh={() => {
          gettasks();
        }}
        onapprovalsuccess={(id, bool) => {}}
      />

      <CurrentReminders
        visible={currentreminderpopup}
        data={vehiclereminders}
        activateoutsidecontainerclick={() => {
          setcurrentreminderpopup(false);
        }}
        onapprovalsuccess={(id, bool) => {}}
        updatereminders={(data) => {
          setvehiclereminders(data);
        }}
      />

      <VehicleHistory
        visible={vehiclehistorypopup}
        data={vehiclehistorydata}
        activateoutsidecontainerclick={() => {
          setvehiclehistorypopup(false);
        }}
        refetchlist={async () => {
          await getAllVehicleSlots(
            "slots",
            "assignedvehicle",
            "==",
            vehiclehistorydata[0].assignedvehicle,
          )
            .then(async (response) => {
              setvehiclehistorydata(response);
            })
            .catch((err) => {
              console.log(err);
              alert(err);
            });
        }}
        onapprovalsuccess={(id, bool) => {}}
        updatereminders={(data) => {
          setvehiclehistorydata(data);
        }}
      />

      <TaskRejection
        visible={rejectionpopup}
        activateoutsidecontainerclick={() => {
          setrejectionpopup(false);
        }}
        reject={async (reason) => {
          setrejectionpopup(false);

          await updateItem(
            "supervisortasks",
            supervisortasks[rejectionindex].id,
            {
              Status: "Rejected",
              RejectionReason: reason,
            },
          )
            .then((response) => {
              let dataset = [...supervisortasks];
              dataset[rejectionindex]["Status"] = "Rejected";
              dataset[rejectionindex]["RejectionReason"] = "reason";

              setsupervisortasks(dataset);
            })
            .catch((err) => {
              alert("update task error " + err);
            });
        }}
        onapprovalsuccess={(id, bool) => {}}
      />
    </div>
  );
}

export default ToDolist;
